import ModulePage from "../ModulePage/ModulePage";

const Home = () => <ModulePage />;

export default Home;
